export const DIALOG_ZINDEX = 160;
export const DIALOG_OPEN_DATA_ATTRIBUTE = 'data-dialog-open';
